import React, { Component } from 'react';
import { Image, Button } from 'semantic-ui-react'
// import './Slide.css';
class Slide extends Component {
  constructor(props){
    super(props)

  }
  componentDidUpdate(prevProps, prevState){
    if (prevProps.selected == false && this.props.selected){      
      this.setState({ open: this.state.open, selected: true});
      this.props.set_circuit(this.props.circuit, !window.thumbs.state.opening);
    }

    // if (prevProps.selected == false && this.props.selected && !this.state.selected){      
    //   this.setState({ open: this.state.open, selected: true})
    //   this.props.set_circuit(this.props.circuit.data, this);
    // }else{
    //   if (!this.props.selected && this.state.selected){
    //     this.setState({ open: this.state.open, selected: false})
    //   }
    // }
  }
  
  state = { open: false, selected: false }

  
  render() {

    const borderStyle = {
      borderWidth: this.props.selected ? 3 : 1,
      position: 'relative',
      backgroundColor: this.props.circuit.bg_color,
      borderStyle: 'solid', borderColor: this.props.selected ? 'coral' : 'gray', paddingBottom: 8
    }
    
    return (
      <div className="slide" 
      style={borderStyle} onClick={()=> {
        if (!window.thumbs.state.opening){
          window.thumbs.sync();
          setTimeout(()=>{
            this.props.select(this.props.number-1)
          }, 1)        
        }
      }} >
        {this.props.circuit.base64_shapshot != "" &&
        <Image src={"data:image/png;base64," +this.props.circuit.base64_shapshot} size='small' />
        }
        <div style={{height: 7, width: '100%', position: 'absolute', left: 0, bottom: 5}}>
        <p className={this.props.selected ? "slide_caption_selected" : "slide_caption"} >
            {this.props.number}
        </p>
        {!this.props.single &&
        <Button onClick={(e)=>{
          
          e.stopPropagation();
          this.props.setConfirm(this.props.number-1)
          }
        }
        style={{position: 'relative', top: -25, padding: 0, backgroundColor: 'transparent', color: 'red' }}  icon='delete' size='mini' />
        }
        
        
        
        </div>  
      </div>
    );
  }
}

export default Slide;
